import o from "./index247.mjs";
import r from "./index248.mjs";
import t from "./index235.mjs";
import m from "./index249.mjs";
const a = o({
  themeId: t,
  defaultTheme: r,
  rootShouldForwardProp: m
});
export {
  a as default,
  m as rootShouldForwardProp
};
